export default "__VITE_ASSET__DMZB9FWr__"